import request from '@/utils/request'
/**
 * 获取国产药品信息和进口药品信息的接口
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=663
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=664
 */
export function druglist({ type, params }) {
  return request({
    url: type === 'guonei' ? '/product_standard/domestic_drugs' : '/product_standard/imported_drugs',
    method: 'get',
    params: params
  })
}

/**
 * 标准库 医生从业人员 医生数据库列表接口
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=680
 */
const list = {
  kehuData: 'standard', // 客户主数据
  huishouData: 'hui-shou-zhan', // 回收站
  newapply: 'standard_new_apply', // 新增申请
  jiucuo: 'standard_jiucuo', // 纠错
  shanchu: 'standard_shanchu', // 删除
  companyData: 'sheng-chan-qi-ye',
  shangyeData: 'shang-ye',
  yiliaoData: 'yi-liao-ji-gou',
  yaodianData: 'yao-dian',
  yiyuanData: 'yi-yuan',
  zhongduanData: 'disan-zhongduan',
  jiyaoData: 'ji-yao',
  guochanData: 'guochan-yaopin',
  jinkouData: 'jinkou-yaopin',
  yibaoData: 'yibao-yaopin',
  doctorData: 'doctor'
}

export function publicDataList(params, name) {
  return request({
    url: `/${list[name]}/get-list`,
    method: 'get',
    params: params
  })
}

/**
 * 数据库主数据增加
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=698 医疗机构增加
 */
export function mainDataAdd(params, name) {
  return request({
    url: `/${list[name]}/add`,
    method: 'post',
    data: params
  })
}

/**
 * 数据库数据列表 编辑 获得编辑数据
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=691 获取医疗机构编辑的数据
 */
export function getEditMaindata(id, name) {
  return request({
    url: `/${list[name]}/get-info`,
    method: 'get',
    params: { id }
  })
}

/**
 * 数据库编辑操作 保存编辑数据
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=699 保存医疗机构编辑的数据
 */
export function setEditMaindata(params, name) {
  return request({
    url: `/${list[name]}/edit`,
    method: 'post',
    data: params
  })
}

/**
 * 数据库删除和批量删除操作
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=711
 */
export function delMaindata(ids, pageName) {
  const obj = {
    'kehuData': 'Standard',
    'companyData': 'ShengChanQiYe',
    'shangyeData': 'ServiceInfoCorp',
    'yiliaoData': 'YiLiaoJiGou',
    'yaodianData': 'ServiceInfoShop',
    'yiyuanData': 'ServiceInfoHospital',
    'zhongduanData': 'DiSanZhongDuan'
  }
  return request({
    url: '/standard/hos-del',
    method: 'post',
    data: { ids: ids, type: obj[pageName] }
  })
}

// 跟上面的删除一样 只不过多了一个参数
export function delMaindataNew(data) {
  return request({
    url: '/standard/hos-del',
    method: 'post',
    data: data
  })
}
/**
 * 数据库还原和批量还原操作
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=712
 */
export function reventMaindata(id) {
  return request({
    url: '/standard/recycle-back',
    method: 'post',
    data: { ids: id }
  })
}

/**
 * 检查名字是否重复
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=701
 * @param {name} 名称 曾用名 别名
 * @params {id} 如果是编辑 主键 id
 */
export function checkNameExist(params) {
  return request({
    url: '/standard/check-name-exists',
    method: 'get',
    params: params
  })
}

// *********************************************************************************************** //
/**
 * 纠错分组列表
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=678
 */
export function correction(params) {
  return request({
    url: '/correction/get-group-list',
    method: 'get',
    params: params
  })
}

/**
 * 纠错信息详情
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=678
 */
export function SingleCorrection(params) {
  return request({
    url: '/correction/get-list',
    method: 'get',
    params: params
  })
}
/**
 * 纠错-信息列表
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=678
 */

export function getFixedInfo(params, name) {
  return request({
    url: `/${name}/get-info`,
    method: 'get',
    params: params
  })
}
/**
 * 纠错-信息提交
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=678
 */
export function fixedInfoSubmit(params, name) {
  return request({
    url: `/${name}/correct-info`,
    method: 'post',
    params: params
  })
}
/**
 * 获取医保地区（省）
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=678
 */
export function getYiBaoArea() {
  const params = {
    search_type: 'YiBao',
    type: 'yibao_area'
  }
  return request({
    url: `standard/get-category`,
    method: 'get',
    params: params
  })
}

/**
 * 从es模糊搜索数据
 * 地址：http://doc.pharmconverge.com/index.php?s=/22&page_id=830
 */
export function replaceData(params) {
  return request({
    url: `standard/get-replace-data-by-es`,
    method: 'post',
    data: params
  })
}

/**
 * 20-09-28 自定义数据库 审核通过r_id 获取详情 废弃
 * 地址: http://doc.pharmconverge.com/index.php?s=/22&page_id=890
 */

// export function getCustomCheckInfo(data) {
//   return request({
//     url: 'standard_self/info',
//     method: 'get',
//     params: data
//   })
// }

/**
 * 20-10-29 自定义数据库 审核 纠错 删除 获取数据信息
 * 地址: http://doc.pharmconverge.com/index.php?s=/22&page_id=890
 */

export function getCustomCheckInfo(data) {
  return request({
    url: 'stddata/all-info',
    method: 'get',
    params: data
  })
}

/**
 * 20-09-28 自定义数据库 审核 驳回
 * 地址: http://doc.pharmconverge.com/index.php?s=/22&page_id=891
 */

export function customCheckReject(data) {
  return request({
    url: 'standard_self/reject',
    method: 'post',
    data: data
  })
}

//   自定义数据库 恢复审核 驳回

export function customHuiCheckReject(data) {
  return request({
    url: 'stddata/huifu-reject',
    method: 'post',
    data: data
  })
}

//   自定义数据库 恢复审核 通过

export function customHuiCheckPass(data) {
  return request({
    url: 'stddata/huifu-pass',
    method: 'post',
    data: data
  })
}

/**
 * 20-09-28 自定义数据库 审核 通过
 * 地址: http://doc.pharmconverge.com/index.php?s=/22&page_id=892
 */

export function customCheckPass(data) {
  return request({
    url: 'stddata/huifu-pass',
    method: 'post',
    data: data
  })
}

/**
 * 20-10-29 自定义数据库 纠错审核驳回
 */

export function customJiuReject(data) {
  return request({
    url: 'stddata/jiucuo-reject',
    method: 'post',
    data: data
  })
}

/**
 * 20-10-29 自定义数据库 纠错审核通过
 */

export function customJiuPass(data) {
  return request({
    url: 'stddata/jiucuo-pass',
    method: 'post',
    data: data
  })
}

/**
 * 20-10-29 自定义数据库 删除审核驳回
 */

export function customDelReject(data) {
  return request({
    url: 'stddata/del-reject',
    method: 'post',
    data: data
  })
}

/**
 * 20-10-29 自定义数据库 删除审核通过
 */

export function customDelPass(data) {
  return request({
    url: 'stddata/del-pass',
    method: 'post',
    data: data
  })
}
